const secondary = {
    social_bind_with: 'Già un account? Accedi per collegare {{methods, list(type: disjunction;)}} con la tua identità sociale.',
};
export default Object.freeze(secondary);
